import { render, staticRenderFns } from "./UploadXlsWithReference.vue?vue&type=template&id=13bff740"
import script from "./UploadXlsWithReference.vue?vue&type=script&lang=js"
export * from "./UploadXlsWithReference.vue?vue&type=script&lang=js"
import style0 from "./UploadXlsWithReference.vue?vue&type=style&index=0&id=13bff740&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports